module.exports = __webpack_public_path__ + "img/btn_link_4.ef1c7819.png";